import { render, staticRenderFns } from "./OutboundCockpit.vue?vue&type=template&id=82cfcf5e&scoped=true"
import script from "./OutboundCockpit.vue?vue&type=script&lang=js"
export * from "./OutboundCockpit.vue?vue&type=script&lang=js"
import style0 from "./OutboundCockpit.vue?vue&type=style&index=0&id=82cfcf5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cfcf5e",
  null
  
)

export default component.exports